import { ITheme } from "../typings/Theme";

export const getThemeColors = (theme: ITheme) => {
  return [
    theme.headingsAndLinksColor,
    theme.bodyTextColor,
    theme.formFieldsBgColor,
    theme.formFieldsBorderColor,
    theme.formFieldsLabelColor,
    theme.primaryBtnBgColor,
    theme.primaryBtnBorderColor,
    theme.primaryBtnLabelColor,
    theme.secondaryBtnBgColor,
    theme.secondaryBtnBorderColor,
    theme.secondaryBtnLabelColor,
    theme.pageBgColor,
    theme.pageBordersAndLinesColor,
    theme.priceColor,
    theme.salePriceColor,
  ];
};
